"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6136],{

/***/ 65651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ logoAlt; },
/* harmony export */   "j1": function() { return /* binding */ logoPath; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46096);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30233);




const logoPath = "/images/graphpad/logo/logo-graphpad-white.svg";
const logoAlt = "GraphPad by Dotmatics";
const prerenderedLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    href: _routes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].external.index */ .Z.external.index,
    imgSrc: logoPath,
    alt: logoAlt,
    "data-qa-selector": "header-logo",
    className: "max-w-45"
});
/* harmony default export */ __webpack_exports__["ZP"] = (prerenderedLogo);


/***/ }),

/***/ 76136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_SiteLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js + 1 modules
var Footer = __webpack_require__(9458);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Container.js
var Container = __webpack_require__(38661);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Main.js
var Main = __webpack_require__(78682);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Nav.js
var Nav = __webpack_require__(53512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/CopyrightV3.js
var CopyrightV3 = __webpack_require__(20111);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/LogoV3.js
var LogoV3 = __webpack_require__(74417);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
// EXTERNAL MODULE: ./src/PrerenderedLogo/index.js
var PrerenderedLogo = __webpack_require__(65651);
;// CONCATENATED MODULE: ./src/SiteFooter/index.js












const SiteFooter = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("footer");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* default */.Z, {
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavRow */.z4, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("SCIENTIFIC_SOFTWARE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.graphPadPrism */.Z.graphPadPrism,
                                                        children: t("GRAPHPAD_PRISM")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.freeTrial */.Z.external.freeTrial,
                                                        children: t("PRISM_FREE_TRIAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.enterprise */.Z.enterprise,
                                                        children: t("ENTERPRISE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.customers */.Z.customers,
                                                        children: t("PRISM_CUSTOMERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.instat */.Z.external.instat,
                                                        children: t("INSTAT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.features.powerAnalysis */.Z.features.powerAnalysis,
                                                        children: t("STATMATE")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("HOW_TO_BUY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.howToBuy */.Z.external.howToBuy,
                                                        children: t("PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.student */.Z.external.student,
                                                        children: t("STUDENT_PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.professorCourseLicenses */.Z.professorCourseLicenses,
                                                        children: t("PROFESSOR_COURSE_LICENSES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.graphPadChina */.Z.external.graphPadChina,
                                                        children: t("GRAPHPAD_CHINA")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("DATA_ANALYSIS_RESOURCES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.quickCalcs */.Z.external.quickCalcs,
                                                        children: t("QUICKCALCS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.resources */.Z.resources,
                                                        children: t("PRODUCT_TUTORIALS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.statisticsGuide */.Z.external.statisticsGuide,
                                                        children: t("STATISTICS_GUIDE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.curveFittingGuide */.Z.external.curveFittingGuide,
                                                        children: t("CURVE_FITTING_GUIDE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.prismAcademy */.Z.prismAcademy,
                                                        children: t("PRISM_ACADEMY")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("HELP")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.support */.Z.external.support,
                                                        children: t("SUPPORT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.prismUserGuide */.Z.external.prismUserGuide,
                                                        children: t("PRISM_USER_GUIDE")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("COMPANY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.about */.Z.about,
                                                        children: t("ABOUT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.careers */.Z.external.careers,
                                                        children: t("CAREERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.portfolio */.Z.external.portfolio,
                                                        children: t("PORTFOLIO")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.dotmatics */.Z.external.dotmatics,
                                                        children: t("DOTMATICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.contacts */.Z.external.contacts,
                                                        children: t("CONTACT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightV3/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoV3/* default */.Z, {
                        href: routes/* default.external.index */.Z.external.index,
                        logoPath: PrerenderedLogo/* logoPath */.j1,
                        logoAlt: PrerenderedLogo/* logoAlt */.B$
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightV3/* FooterCopyrightV3Text */.JG, {
                        children: [
                            t("ALL_RIGHTS_RESERVED", {
                                yyyy: new Date().getFullYear()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Link */.QC, {
                                href: routes/* default.external.termsOfService */.Z.external.termsOfService,
                                children: t("TERMS")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Text.Separate */.JG.Separate, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Link */.QC, {
                                href: routes/* default.external.privacyPolicy */.Z.external.privacyPolicy,
                                children: t("PRIVACY")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Text.Separate */.JG.Separate, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Link */.QC, {
                                href: routes/* default.external.donotsell */.Z.external.donotsell,
                                children: t("DONOTSELL")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var src_SiteFooter = (SiteFooter);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js + 1 modules
var Navbar = __webpack_require__(37762);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Item.js
var Item = __webpack_require__(88881);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Link.js
var Link = __webpack_require__(81453);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarSearch/index.js + 1 modules
var NavbarSearch = __webpack_require__(2176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js + 1 modules
var Form = __webpack_require__(22950);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js + 2 modules
var Input = __webpack_require__(6470);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/index.js + 1 modules
var TopBar = __webpack_require__(88311);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Logo.js
var Logo = __webpack_require__(39755);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Nav.js
var TopBar_Nav = __webpack_require__(65717);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var atomic_react_Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/TopBar/Dropdown.js
var Dropdown = __webpack_require__(43223);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/index.js + 1 modules
var NavbarDropdown = __webpack_require__(86210);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/Title.js
var Title = __webpack_require__(36555);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/Menu.js
var Menu = __webpack_require__(1385);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/index.js + 1 modules
var MegaMenu = __webpack_require__(69514);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Item.js
var MegaMenu_Item = __webpack_require__(4991);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Grid.js
var Grid = __webpack_require__(15062);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/ButtonTheme/index.js + 1 modules
var ButtonTheme = __webpack_require__(10980);
;// CONCATENATED MODULE: ./src/SiteHeader/PlatformTopBar.js











const PlatformTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu/* default */.Z, {
                utility: {
                    justify: "start"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                    md: 8,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "l",
                                    fontColor: "white",
                                    fontWeight: "bold"
                                },
                                children: t("TOPBAR.PLATFORM.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                sx: {
                                    fontSize: "s",
                                    fontColor: "white"
                                },
                                children: t("TOPBAR.PLATFORM.DESC")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                                href: routes/* default.external.platform */.Z.external.platform,
                                styleType: "topbar",
                                spacing: {
                                    px: 5,
                                    py: 3,
                                    mt: 4
                                },
                                target: "_blank",
                                children: [
                                    t("TOPBAR.PLATFORM.BTN"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        spacing: {
                                            ml: 4
                                        },
                                        name: "link-ext"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/images/dotmatics/lab-archives/top-bar/platform.png",
                className: "position-absolute top-0 right-0"
            })
        ]
    });
};
/* harmony default export */ var SiteHeader_PlatformTopBar = (PlatformTopBar);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/MegaMenuBlockLink.js
var MegaMenuBlockLink = __webpack_require__(80178);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var atomic_react_Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./src/SiteHeader/ProductsTopBar.js










const ProductsTopBar = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    const utmSiteName = "graphpad";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu/* default */.Z, {
        spacing: {
            py: 1
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: "#",
                    onClick: (e)=>e.preventDefault(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Prism.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.PRISM")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.geneious */.Z.external.products.geneious,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Geneious.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.GENEIOUS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.snapgene */.Z.external.products.snapgene,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-SnapGene.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.SNAPGENE")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.labArchives */.Z.external.products.labArchives,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-LabArchives.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.LABARCHIVES")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.proteinMetrics */.Z.external.products.proteinMetrics,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-Protein-Metrics.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.PROTEINMETRIC")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.omiq */.Z.external.products.omiq,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-OMIQ.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.OMIQ")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.fcsExpress */.Z.external.products.fcsExpress,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-FCS-Express.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.FCSEXPRESS")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                lg: 3,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenuBlockLink/* default */.Z, {
                    href: t("TOPBAR.PRODUCTS.UTM_LINK", {
                        mainLink: routes/* default.external.products.nQuery */.Z.external.products.nQuery,
                        utmSiteName
                    }),
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atomic_react_Grid/* Row */.X2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    auto: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Image */.Z.Image, {
                                        src: "/images/dotmatics/lab-archives/top-bar/PreNav-Logo-nQuery.svg"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Grid/* Col */.JX, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Icon */.Z.Icon, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuBlockLink/* default.Description */.Z.Description, {
                            children: t("TOPBAR.PRODUCTS.NQUERY")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* MegaMenuCol */.p, {
                sm: 12,
                md: 12,
                lg: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTheme/* default.Link */.Z.Link, {
                    href: routes/* default.external.portfolio */.Z.external.portfolio,
                    spacing: {
                        px: 5,
                        py: 3,
                        mt: 4,
                        mb: 8
                    },
                    styleType: "topbar",
                    target: "_blank",
                    children: [
                        t("TOPBAR.PRODUCTS.EXPLORE_THE_APPLICATION"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            spacing: {
                                ml: 4
                            },
                            name: "link-ext"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SiteHeader_ProductsTopBar = (ProductsTopBar);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/MegaMenu/Title.js
var MegaMenu_Title = __webpack_require__(40535);
;// CONCATENATED MODULE: ./src/SiteHeader/PrismDropdown.js








const PrismDropdown = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* MegaMenuCol */.p, {
                md: 6,
                lg: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Title/* default */.Z, {
                        children: t("PRISM_DROPDOWN.FEATURES.INDEX")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: MegaMenu_Item/* default.Link */.Z.Link,
                                sx: {
                                    fontColor: "black",
                                    fontWeight: 400,
                                    hover: {
                                        fontColor: "2"
                                    }
                                },
                                spacing: {
                                    sm: {
                                        pb: 0
                                    },
                                    md: {
                                        pb: 0
                                    }
                                },
                                href: "/features",
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_1.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default.Description */.Z.Description, {
                                spacing: {
                                    mt: 0
                                },
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_1.DESCRIPTION")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: MegaMenu_Item/* default.Link */.Z.Link,
                                sx: {
                                    fontColor: "black",
                                    fontWeight: 400,
                                    hover: {
                                        fontColor: "2"
                                    }
                                },
                                spacing: {
                                    sm: {
                                        pb: 0
                                    },
                                    md: {
                                        pb: 0
                                    }
                                },
                                href: "/features#analysis",
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_2.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default.Description */.Z.Description, {
                                spacing: {
                                    mt: 0
                                },
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_2.DESCRIPTION")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: MegaMenu_Item/* default.Link */.Z.Link,
                                sx: {
                                    fontColor: "black",
                                    fontWeight: 400,
                                    hover: {
                                        fontColor: "2"
                                    }
                                },
                                spacing: {
                                    sm: {
                                        pb: 0
                                    },
                                    md: {
                                        pb: 0
                                    }
                                },
                                href: "/features#graphing",
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_3.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default.Description */.Z.Description, {
                                spacing: {
                                    mt: 0
                                },
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_3.DESCRIPTION")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: MegaMenu_Item/* default.Link */.Z.Link,
                                sx: {
                                    fontColor: "black",
                                    fontWeight: 400,
                                    hover: {
                                        fontColor: "2"
                                    }
                                },
                                spacing: {
                                    sm: {
                                        pb: 0
                                    },
                                    md: {
                                        pb: 0
                                    }
                                },
                                href: "/cloud",
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_4.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default.Description */.Z.Description, {
                                spacing: {
                                    mt: 0
                                },
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_4.DESCRIPTION")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: MegaMenu_Item/* default.Link */.Z.Link,
                                sx: {
                                    fontColor: "black",
                                    fontWeight: 400,
                                    hover: {
                                        fontColor: "2"
                                    }
                                },
                                spacing: {
                                    sm: {
                                        pb: 0
                                    },
                                    md: {
                                        pb: 0
                                    }
                                },
                                href: "/updates",
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_5.TITLE")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default.Description */.Z.Description, {
                                spacing: {
                                    mt: 0
                                },
                                children: t("PRISM_DROPDOWN.FEATURES.ITEM_5.DESCRIPTION")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* MegaMenuCol */.p, {
                md: 6,
                lg: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Title/* default */.Z, {
                        children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.INDEX")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            Component: MegaMenu_Item/* default.Link */.Z.Link,
                            sx: {
                                fontColor: "black",
                                fontWeight: 400,
                                hover: {
                                    fontColor: "2"
                                }
                            },
                            spacing: {
                                sm: {
                                    pb: 0
                                },
                                md: {
                                    pb: 0
                                }
                            },
                            href: "/features/prism-anova",
                            children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.ITEM_1.TITLE")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            Component: MegaMenu_Item/* default.Link */.Z.Link,
                            sx: {
                                fontColor: "black",
                                fontWeight: 400,
                                hover: {
                                    fontColor: "2"
                                }
                            },
                            spacing: {
                                sm: {
                                    pb: 0
                                },
                                md: {
                                    pb: 0
                                }
                            },
                            href: "/features/power-analysis",
                            children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.ITEM_2.TITLE")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            Component: MegaMenu_Item/* default.Link */.Z.Link,
                            sx: {
                                fontColor: "black",
                                fontWeight: 400,
                                hover: {
                                    fontColor: "2"
                                }
                            },
                            spacing: {
                                sm: {
                                    pb: 0
                                },
                                md: {
                                    pb: 0
                                }
                            },
                            href: "/features/prism-survival-analysis",
                            children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.ITEM_3.TITLE")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            Component: MegaMenu_Item/* default.Link */.Z.Link,
                            sx: {
                                fontColor: "black",
                                fontWeight: 400,
                                hover: {
                                    fontColor: "2"
                                }
                            },
                            spacing: {
                                sm: {
                                    pb: 0
                                },
                                md: {
                                    pb: 0
                                }
                            },
                            href: "/features/prism-nonlinear-regression",
                            children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.ITEM_4.TITLE")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_Item/* default */.Z, {
                        spacing: {
                            lg: {
                                my: 3
                            },
                            md: {
                                my: 0
                            },
                            sm: {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            Component: MegaMenu_Item/* default.Link */.Z.Link,
                            sx: {
                                fontColor: "black",
                                fontWeight: 400,
                                hover: {
                                    fontColor: "2"
                                }
                            },
                            spacing: {
                                sm: {
                                    pb: 0
                                },
                                md: {
                                    pb: 0
                                }
                            },
                            href: "/features/machine-learning",
                            children: t("PRISM_DROPDOWN.POPULAR_USE_CASES.ITEM_5.TITLE")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SiteHeader_PrismDropdown = ((/* unused pure expression or super */ null && (PrismDropdown)));

;// CONCATENATED MODULE: ./src/SiteHeader/index.js





























const SiteHeader = (param)=>{
    let { isAuthorized =false  } = param;
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBar/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Link/* default */.Z, {
                            href: routes/* default.external.dotmatics */.Z.external.dotmatics,
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/common/dotmatics-logo-white.svg"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_Nav/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                            isMegaMenu: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Title */.Z.Title, {
                                    triangle: true,
                                    triangleProps: {
                                        color: "dotmatics-2",
                                        isOpenColor: "dotmatics-2"
                                    },
                                    children: t("PLATFORM_PRODUCTS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Body */.Z.Body, {
                                    utility: {
                                        bgColor: "dotmatics-6",
                                        border: {
                                            top: {
                                                width: 1,
                                                color: "white--20"
                                            },
                                            bottom: {
                                                width: 1,
                                                color: "white--20"
                                            }
                                        }
                                    },
                                    spacing: {
                                        my: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHeader_PlatformTopBar, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHeader_ProductsTopBar, {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                logo: PrerenderedLogo/* default */.ZP,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                    utility: {
                        lg: {
                            display: "flex",
                            justify: "end"
                        }
                    },
                    sizing: {
                        lg: {
                            w: "full"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                            inverted: true,
                            nav: "primary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarDropdown/* default */.Z, {
                                    isNotClosed: true,
                                    isMegaMenu: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                                            children: t("PRISM")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                            isList: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismDropdown, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        Tag: NextLink/* default */.Z,
                                        href: routes/* default.enterprise */.Z.enterprise,
                                        children: t("ENTERPRISE")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        Tag: NextLink/* default */.Z,
                                        href: routes/* default.resources */.Z.resources,
                                        children: t("RESOURCES")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: routes/* default.external.support */.Z.external.support,
                                        children: t("SUPPORT")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: routes/* default.external.howToBuy */.Z.external.howToBuy,
                                        children: t("HOW_TO_BUY")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                            nav: "secondary",
                            inverted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    secondary: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        href: routes/* default.external.cart */.Z.external.cart,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "shopping-cart"
                                            }),
                                            t("CART")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    secondary: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                        href: routes/* default.myAccount */.Z.myAccount,
                                        className: "nav__item-link",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "user-alt"
                                            }),
                                            " ",
                                            isAuthorized ? t("MY_ACCOUNT") : t("SIGNIN")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarSearch/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                                        method: "get",
                                        action: "/search/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            type: "search",
                                            id: "searchquery",
                                            name: "searchquery",
                                            placeholder: "Search...",
                                            autoComplete: "off"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                    secondary: true,
                                    className: "secondary-nav__item-trial",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default.Link */.Z.Link, {
                                        size: "s",
                                        href: routes/* default.external.freeTrial */.Z.external.freeTrial,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "arrow-to-bottom"
                                            }),
                                            " ",
                                            t("FREE_TRIAL")
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
SiteHeader.propTypes = {
    isAuthorized: prop_types.bool
};
/* harmony default export */ var src_SiteHeader = (SiteHeader);

// EXTERNAL MODULE: ./src/hooks/useIsAuthorized.js
var useIsAuthorized = __webpack_require__(82952);
;// CONCATENATED MODULE: ./src/SiteLayout/index.js







const SiteLayoutPure = (param)=>{
    let { bodyClassName ="" , children , isAuthorized , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        isWrapper: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteHeader, {
                    ...props,
                    isAuthorized: isAuthorized
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Body */.Z.Body, {
                className: bodyClassName,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Footer */.Z.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteFooter, {})
            })
        ]
    });
};
SiteLayoutPure.propTypes = {
    bodyClassName: prop_types.string,
    isAuthorized: prop_types.bool,
    children: prop_types.node,
    hero: prop_types.bool
};
const SiteLayout = (props)=>{
    const isAuthorized = (0,useIsAuthorized/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLayoutPure, {
        ...props,
        isAuthorized: isAuthorized
    });
};
SiteLayout.Pure = SiteLayoutPure;
/* harmony default export */ var src_SiteLayout = (SiteLayout);


/***/ })

}]);